import React, { useEffect, useState } from "react";
import deleteIcon from "../../assets/images/icons/delete.png";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmModal from "../dialog/ConfirmationDialog";
import ConfirmationDialog from "../dialog/ConfirmationDialog";
import { getDomainInfo } from "../../utils/utils";
import { toast } from 'react-toastify'; 

let TOAST_ID = "no-inventory-toast";

function SingleCartProduct({
  id,
  src,
  productName,
  variantname,
  value,
  price,
  mrp,
  delcartitem,
  onQuantityChange,
  newquantity,
  itemIndex,
  stock,
  variant,
  token,
  userData
}) {
  const [quantity, setQuantity] = useState(0);
  const [currentStock, setCurrentStock] = useState(stock);
  const [isValidating, setIsValidating] = useState(false);
  const navigate = useNavigate();
  const { userId } = useParams();
  const { hostname, isPredefinedDomain, uid } = getDomainInfo(userId);
  const [showConfirm, setShowConfirm] = useState(false);
  const [adding,setAdding]=useState(false)

  useEffect(() => {
    setQuantity(newquantity);
  }, [newquantity]);

  const validateCartItem = async (newQuantity) => {
    if (!token || !userData?.id) return { isValid: true }; // Skip if not logged in
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}customer/validate-cart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({
          sellerId: userData.id,
          cartItems: [{
            productId: id,
            variant: variant,
            quantity: newQuantity
          }]
        }),
      });

      return await response.json();
    } catch (error) {
      console.error("Validation error:", error);
      return { isValid: true }; // Assume valid if validation fails
    }
  };

  const handleQuantityChange = async (newQty) => {
    setIsValidating(true);
    try {
      const validation = await validateCartItem(newQty);
      
      if (!validation.isValid) {
        toast.error(validation.message || "Item validation failed", {
          position: "top-center",
          autoClose: 2000,
        });
        return false;
      }

      const variant1Id = variant?.firstVariant?.title?.id || null;
      const variant2Id = variant?.secondVariant?.title?.id || null;
      const stockCheck = await fetchLiveStock(id, variant1Id, variant2Id);

      setCurrentStock(stockCheck);

      if (newQty > stockCheck) {
        toast.warn(`Product Sold Out Only ${stockCheck} item${stockCheck !== 1 ? 's' : ''} available`, {
          position: "top-center",
          autoClose: 2000,
        });

        // ✅ Reset quantity to available stock
        setQuantity(stockCheck);
        onQuantityChange(itemIndex, stockCheck);
        return false;
      }

      setQuantity(newQty);
      onQuantityChange(itemIndex, newQty);
      return true;
    } catch (err) {
      console.error("Quantity update error:", err);
      return false;
    } finally {
      setIsValidating(false);
    }
  };



  const handleIncrement = async () => {
    setIsValidating(true);
    try {
      const variant1Id = variant?.firstVariant?.title?.id || null;
      const variant2Id = variant?.secondVariant?.title?.id || null;
      const stockCheck = await fetchLiveStock(id, variant1Id, variant2Id);
      
      setCurrentStock(stockCheck); // ⬅️ update state

      if (quantity >= stockCheck) {
        toast.warn(`Only ${stockCheck} item${stockCheck !== 1 ? 's' : ''} available`, {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }

      await handleQuantityChange(quantity + 1);
    } catch (err) {
      console.error("Increment error:", err);
    } finally {
      setIsValidating(false);
    }
  };


  const handleDecrement = async () => {
    if (quantity > 1) {
      await handleQuantityChange(quantity - 1);
    }
  };

  // Helper function to remove commas and convert price to a number
  const getCleanedPrice = () => {
    return Number(price);
  };

  // Format the calculated price to show commas in large numbers
  const calculateTotalPrice = () => {
    return (getCleanedPrice() * quantity).toLocaleString();
  };

  const calculateTotalMrp = () => {
    return (Number(mrp) * quantity).toLocaleString();
  };

  const handelimgClick = () => {
    navigate(
      isPredefinedDomain
        ? `/${uid}/productdetails/${productName.replace(/\s+/g, "_")}`
        : `/productdetails/${productName.replace(/\s+/g, "_")}`, {state : {productId:id}}
    );
  };

  const handleCartItemDeletion = () => {
    delcartitem(itemIndex);
    setShowConfirm(false);
  };

  const fetchLiveStock = async (productId, variant1Id = null, variant2Id = null) => {
    try {
      const params = new URLSearchParams({ productId });
      if (variant1Id) params.append("variant1Id", variant1Id);
      if (variant2Id) params.append("variant2Id", variant2Id);

      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}product/get-live-stock?${params.toString()}`);
      const data = await response.json();
      return data.stock || 0;
    } catch (error) {
      console.error("Error checking stock:", error);
      return 0;
    }
  };

  const isS3Url = src?.includes("https://hello-image-bucket.s3");
  
  const defaultImageUrl = process.env.REACT_APP_S3_URL || "default_url_if_missing";

  const imageUrl = isS3Url ? src : defaultImageUrl + src;

  return (
      <div className="order-item">
        <img
            width={84}
            height={93}
            src={imageUrl || "https://via.placeholder.com/84x93"}
            alt={productName}
            onClick={handelimgClick}
            style={{ cursor: "pointer" }}
        />
        <div className="item-details">
          <ConfirmationDialog
              show={showConfirm}
              onClose={() => setShowConfirm(false)}
              onConfirm={handleCartItemDeletion}
              confirmationMessage="Do you want to remove this item from cart?"
          />
          <h3>{productName}</h3>
          <p className="item-size-color">
            {variantname && <span>{variantname}: {value}</span>}
           </p>
          <div className="quantity-control">
          <button 
            onClick={handleDecrement}
            disabled={adding}
          >
            <i className="fa-solid fa-minus minus-circle-icon circle-icon"></i>
          </button>
          <span>{quantity}</span>
          <button
            onClick={handleIncrement}
            disabled={isValidating}
            style={{
              opacity: isValidating ? 0.5 : 1,
              cursor: isValidating ? "not-allowed" : "pointer",
            }}
          >
            <i className="fa-solid fa-plus plus-circle-icon circle-icon"></i>
            {isValidating && <span className="spinner-border spinner-border-sm ms-1"></span>}
          </button>

        </div>
        </div>
        <div className="price-info">
          {price === 0 ? (
            <div className="current-price">₹ {calculateTotalMrp()}</div>
          ) : (
            <>
              <div className="current-price">₹ {calculateTotalPrice()}</div>
              {mrp > price && <div className="original-price">₹ {calculateTotalMrp()}</div>}
            </>
          )}
          <button onClick={() => setShowConfirm(true)}>Remove</button>
        </div>
      </div>
    // <div className="d-flex gap-3">
    //   <div className="col-3">
    //     <img
    //       width={84}
    //       height={93}
    //       src={src || "https://via.placeholder.com/84x93"}
    //       alt={productName}
    //       onClick={handelimgClick}
    //       style={{ cursor: "pointer" }}
    //     />
    //   </div>
    //   <div className="col-8">
    //     <div className="col-12 d-flex justify-content-between">
    //       <ConfirmationDialog
    //         show={showConfirm}
    //         onClose={() => setShowConfirm(false)}
    //         onConfirm={handleCartItemDeletion}
    //         confirmationMessage={
    //           "Are you sure you want to delete this item from cart!"
    //         }
    //       />
    //       <div style={{ display: "inline-block" }}>
    //         <p
    //           style={{
    //             marginBottom: "0px",
    //             fontSize: "14px",
    //             fontWeight: "500",
    //           }}
    //         >
    //           {productName}
    //         </p>
    //         <p style={{ fontSize: "12px", marginBottom: "0px" }}>
    //           ({variantname} : {value})
    //         </p>
    //       </div>
    //       <div style={{ display: "inline-block", cursor: "pointer" }}>
    //         <img
    //           onClick={() => setShowConfirm(true)}
    //           src={deleteIcon}
    //           alt="Delete"
    //         />
    //       </div>
    //     </div>
    //     <div className="col-12 d-flex justify-content-between">
    //       <div style={{ alignContent: "center" }}>
    //         <p
    //           className="ProductPrice"
    //           style={{
    //             fontWeight: "600",
    //             fontSize: "16px",
    //             marginBottom: "0px",
    //           }}
    //         >
    //           Rs. {calculateTotalPrice()}
    //         </p>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export default SingleCartProduct;
